import { Context } from "../context";
import { useContext } from "react";
import { largeFont, smallFont } from "../utils/styles";

export default function ({ name, links }) {
  const { theme } = useContext(Context);
  return (
    <div>
      <style jsx>{`
        a.link {
          text-decoration: underline;
          text-underline-position: under;
          color: ${theme.accentTextColor};
          font-size: ${smallFont};
        }
        p {
          font-size: ${smallFont};
          line-height: 160%;
          margin: 1rem 0;
        }
        li {
          margin-bottom: 1rem;
        }
        .title {
          color: ${theme.accentTextColor};
          font-weight: bold;
          font-size: ${largeFont};
          line-height: 125%;
          margin: 1.5rem 0;
        }
      `}</style>
      <a id="links">
        <h3 className="title">How to Play</h3>
      </a>
      <p>
        Use the <strong>official link{links.length > 1 ? "s" : ""}</strong> below to get {name}:
      </p>
      <ul className="links">
        {links.map((link) => (
          <li key={link.slug}>
            <a className="link" href={link.url}>
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
